/**
 * gestureCreator.ts
 * 「ジェスチャー作成」画面の表示状態。設定ダイアログの外側で描画するため外部ストアで持つ。
 */
import { useSyncExternalStore } from 'react';

const getCreateTourStorageKey = (userSub: string) =>
  `filo:create-product-tour:v1:${encodeURIComponent(userSub)}`;

export const hasConfirmedCreateTour = (userSub: string): boolean => {
  try {
    return localStorage.getItem(getCreateTourStorageKey(userSub)) === 'true';
  } catch {
    return false;
  }
};

export const confirmCreateTour = (userSub: string): void => {
  try {
    localStorage.setItem(getCreateTourStorageKey(userSub), 'true');
  } catch {
    // The tour remains usable when storage is unavailable.
  }
};

let request: { open: boolean; motionId: string | null; startTour: boolean } = {
  open: false,
  motionId: null,
  startTour: false,
};
const listeners = new Set<() => void>();

const publish = (next: { open: boolean; motionId: string | null; startTour: boolean }) => {
  if (request.open === next.open && request.motionId === next.motionId && request.startTour === next.startTour) return;
  request = next;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => request;

export const openGestureCreator = (motionId?: string, startTour = false) => publish({
  open: true,
  motionId: motionId ?? null,
  startTour,
});
export const closeGestureCreator = () => publish({ open: false, motionId: null, startTour: false });

export const useGestureCreatorRequest = () =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
